import {Component, inject, OnInit, signal} from "@angular/core";
import {CommonModule} from "@angular/common";
import {HeaderService} from "../../../services/header.service";
import {ApiService} from "../../../services/api.service";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import {Router} from "@angular/router";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {AppUser, UserService} from "../../../services/user.service";

@Component({
  selector: "app-reset-password",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, MatButtonModule],
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  headerService = inject(HeaderService);
  apiService = inject(ApiService);
  userService = inject(UserService);
  formBuilder = inject(FormBuilder);
  router = inject(Router);
  hide = signal<boolean>(true);

  ngOnInit(): void {
    this.headerService.setHeaderIcon("bi bi-lock-fill");
    this.headerService.setHeaderTitle("Password zurücksetzen");
    this.headerService.setHeaderSubTitle("Bitte ändern Sie ihr Passwort");
  }

  public passwordUpdateForm: FormGroup = new FormGroup(
    {
      password: new FormControl("", [Validators.required]),
      passwordConfirm: new FormControl(
        "",
        Validators.compose([Validators.required])
      ),
    },
    this.passwordConfirm("password", "passwordConfirm")
  );

  get passwordValue() {
    return this.passwordUpdateForm.get("password")!.value;
  }

  get passwordControl() {
    return this.passwordUpdateForm.get("password");
  }

  get passwordConfirmControl() {
    return this.passwordUpdateForm.get("passwordConfirm")!;
  }

  get passwordConfirmError() {
    const control: AbstractControl = this.passwordConfirmControl;
    return control.hasError("required")
      ? "Bitte bestätige dein neues Password"
      : control.hasError("passwordMismatch")
        ? "Die Passwörter stimmen nicht überein"
        : "";
  }

  passwordConfirm(password: string, confirmPassword: string): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: any } | null => {
      const passwordControl = formGroup.get(password);
      const passwordConfirmControl = formGroup.get(confirmPassword);

      if (!passwordControl || !passwordConfirmControl) {
        return null;
      }
      if (
        passwordConfirmControl.errors &&
        !passwordConfirmControl.errors["passwordMismatch"]
      ) {
        return null;
      }

      if (passwordControl.value !== passwordConfirmControl.value) {
        passwordConfirmControl.setErrors({passwordMismatch: true});
        return {passwordMismatch: true};
      } else {
        passwordConfirmControl.setErrors(null);
        return null;
      }
    };
  }

  async updatePassword() {
    try {
      const newPassword = this.passwordUpdateForm.get("password")!.value;
      const userId = this.userService.user()?.id!;
      try {
        await this.apiService.updatePassword(newPassword, userId);
      } catch (passwordError: any) {
        // Spezifische Behandlung für Passwort-Fehler
        if (passwordError.error_code === 'weak_password') {
          const reasons = passwordError.weak_password?.reasons || [];
          let errorMessage = 'Das Passwort entspricht nicht den Sicherheitsanforderungen:';

          if (reasons.includes('length')) {
            errorMessage += '\n- Mindestens 6 Zeichen erforderlich';
          }

          alert(errorMessage);
          return; // Workflow hier stoppen
        } else {
          // Andere Passwort-Fehler
          alert('Fehler beim Aktualisieren des Passworts: ' + (passwordError.msg || passwordError.message));
          return;
        }
      }

      this.apiService.getSingleUserById(userId).subscribe({
        next: (userData) => {
          const currentUser = this.userService.user();
          const updatedUser = {...currentUser, ...userData} as AppUser;
          debugger;
          console.log('Updated user data:', updatedUser);

          this.userService.setUser(updatedUser);
          if (updatedUser.app_metadata['userrole'] === 'Admin') {
            this.router.navigate(["/admin/dashboard"]);
          } else {
            this.router.navigate(["/dashboard"]);
          }
        },
        error: (error) => {
          console.error('Error refreshing user data:', error);
          // Fallback: zur Login-Seite redirecten
          this.router.navigate(["/login"]);
        }
      })
    } catch (error) {
      console.error('Error updating password:', error);
    }
  }
}
